export default __webpack_public_path__ + "static/media/white-chevron-down.647c2eb0.svg";